<script setup lang="ts">
import AppButton from '~/components/AppButton.vue'
import CmsImage from '~/layers/cms/app/components/cms/CmsImage.vue'
import type { CmsCustomComponentType } from '~/layers/cms/app/types/cmsTypes'

const props = defineProps<{
  cmsDataPath: (string | number)[]
}>()
const nazwa_komponentu = 'Teksty/Cennik'
const component_default_values: CmsCustomComponentType = {
  id: { value: undefined, default_value: 'Lorem Ipsum', settingType: 'text', setting_label: 'zmien id' }
}
</script>

<template>
  <CmsCustomComponent
    v-slot="{ component_values }"
    :cms-data-path="[...props.cmsDataPath]"
    :component-name="nazwa_komponentu"
    :defaults="component_default_values"
    :open-options="true"
  >
    <div
      :id="component_values?.id?.value"
      class="px-2xl py-20 flex flex-col gap-7.5"
    >
      <div class="flex flex-col gap-7.5">
        <span class="text-H2 text-Tekst text-center">
          <CmsText
            :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_1']"
          />
        </span>
        <span class="text-H4 text-Tekst text-center">
          <CmsText
            :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_2']"
          />
        </span>
      </div>
      <div class="flex flex-col xl:grid grid-cols-2 grid-rows-1 gap-7.5">
        <div class="p-10 bg-background-2 rounded-3xl xl:rounded-[70px] flex flex-col justify-between gap-10">
          <div class="flex flex-col gap-10">
            <div class="py-1 border-b border-Tertiary w-fit self-center">
              <span class="text-H3 text-Tekst">
                <CmsText
                  :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_3']"
                />
              </span>
            </div>
            <div class="flex flex-col xl:flex-row gap-12 justify-between">
              <div class="flex flex-col gap-10">
                <div class="bg-background-1 flex flex-col gap-2.5 p-10 rounded-3xl">
                  <span class="text-H4 text-Tekst text-center">
                    <CmsText
                      :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_4']"
                    />
                  </span>
                  <span class="text-H3 text-Tekst font-semibold text-center">
                    <CmsText
                      :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_5']"
                    />
                  </span>
                </div>
                <div class="bg-background-1 flex flex-col gap-2.5 p-10 rounded-3xl">
                  <span class="text-H4 text-Tekst text-center">
                    <CmsText
                      :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_6']"
                    />
                  </span>
                  <span class="text-H3 text-Tekst font-semibold text-center">
                    <CmsText
                      :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_7']"
                    />
                  </span>
                </div>
              </div>
              <div class="flex flex-col items-stretch gap-5">
                <div class="py-1 border-b border-Tertiary w-fit">
                  <span class="text-H4 text-Tekst font-semibold">
                    <CmsText
                      :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_8']"
                    />
                  </span>
                </div>
                <CmsCustomComponentList
                  v-slot="{ component_values: componentListValues }"
                  :cms-data-path="[...props.cmsDataPath, 'component_data', 'list_1']"
                  :open-options="true"
                  :component-name="nazwa_komponentu"
                  class="min-w-5 min-h-5 flex flex-col gap-2.5 w-full items-stretch"
                >
                  <div
                    v-for="(item, index) in componentListValues"
                    :key="JSON.stringify(item)"
                    class="flex flex-row gap-5 items-center w-full"
                  >
                    <CmsImage
                      :cms-data-path="[...props.cmsDataPath, 'component_data', 'list_1', 'component_data', index, 'image']"
                      class="object-contain w-10 h-9"
                    />
                    <div class="border-b border-Tertiary">
                      <span class="text-Paragraph text-Tekst">
                        <CmsText
                          :cms-data-path="[...props.cmsDataPath, 'component_data', 'list_1', 'component_data', index, 'text']"
                        />
                      </span>
                    </div>
                  </div>
                </CmsCustomComponentList>
              </div>
            </div>
          </div>
          <div class="hidden xl:flex flex-col items-center">
            <span class="text-Tekst">
              <CmsText
                :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_9']"
              />
            </span>
          </div>
          <CmsLink
            v-slot="{ link }"
            :cms-data-path="[...props.cmsDataPath, 'component_data', 'link_11']"
            class="xl:hidden flex"
          >
            <AppButton
              :href="link?.href"
              :target="link?.target"
              button-theme="Primary"
            >
              <div class="flex flex-col xl:flex-row gap-2 items-center">
                <span class="link-text">{{ link?.link_text ?? 'Lorem Ipsum' }}</span>
              </div>
            </AppButton>
          </CmsLink>
        </div>
        <div class="p-10 bg-background-2 rounded-3xl xl:rounded-[70px] flex flex-col justify-between gap-10">
          <div class="flex flex-col gap-10">
            <div class="py-1 border-b border-Tertiary w-fit flex self-center">
              <span class="text-H3 text-Tekst">
                <CmsText
                  :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_10']"
                />
              </span>
            </div>
            <div class="flex flex-col xl:flex-row gap-10 justify-between">
              <div class="flex flex-col gap-10">
                <div class="bg-background-1 flex flex-col gap-2.5 p-10 rounded-3xl">
                  <span class="text-H4 text-Tekst text-center">              <CmsText
                    :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_11']"
                  /></span>
                  <span class="text-H3 text-Tekst font-semibold text-center">              <CmsText
                    :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_12']"
                  /></span>
                </div>
                <span class="text-Paragraph text-Tekst text-center">              <CmsText
                  :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_13']"
                /></span>
              </div>
              <div class="flex flex-col gap-5">
                <div class="py-1 border-b border-Tertiary w-fit">
                  <span class="text-H4 text-Tekst font-semibold">              <CmsText
                    :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_14']"
                  /></span>
                </div>
                <CmsCustomComponentList
                  v-slot="{ component_values: componentListValues }"
                  :cms-data-path="[...props.cmsDataPath, 'component_data', 'list_2']"
                  :open-options="true"
                  :component-name="nazwa_komponentu"
                  class="min-w-5 min-h-5 flex flex-col gap-2.5 items-stretch w-full"
                >
                  <div
                    v-for="(item, index) in componentListValues"
                    :key="JSON.stringify(item)"
                    class="flex flex-row gap-5 items-center w-full"
                  >
                    <CmsImage
                      :cms-data-path="[...props.cmsDataPath, 'component_data', 'list_2', 'component_data', index, 'image']"
                      class="object-contain w-10 h-9"
                    />
                    <div class="border-b border-Tertiary">
                      <span class="text-Paragraph text-Tekst">
                        <CmsText
                          :cms-data-path="[...props.cmsDataPath, 'component_data', 'list_2', 'component_data', index, 'text']"
                        />
                      </span>
                    </div>
                  </div>
                </CmsCustomComponentList>
              </div>
            </div>
          </div>
          <div class="hidden xl:flex flex-col items-center">
            <span class="text-Tekst">
              <CmsText
                :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_15']"
              />
            </span>
          </div>
          <CmsLink
            v-slot="{ link }"
            :cms-data-path="[...props.cmsDataPath, 'component_data', 'link_12']"
            class="xl:hidden flex"
          >
            <AppButton
              :href="link?.href"
              :target="link?.target"
              button-theme="Primary"
            >
              <div class="flex flex-col xl:flex-row gap-2 items-center">
                <span class="link-text">{{ link?.link_text ?? 'Lorem Ipsum' }}</span>
              </div>
            </AppButton>
          </CmsLink>
        </div>
      </div>
    </div>
  </CmsCustomComponent>
</template>
